export default {
  placeholder: 'Vyberte štítok',
  createTag: 'Vytvoriť štítok udalosti',
};
